import classNames from "classnames";
import PropTypes from "prop-types";
import { MdDynamicFeed } from "react-icons/md";

const SignalFeedToggle = ({ active, onToggle, label }) => (
  <button
    type="button"
    aria-pressed={active}
    className={classNames("projects-scope-toggle__btn", {
      "projects-scope-toggle__btn--active": active,
    })}
    onClick={onToggle}
  >
    <MdDynamicFeed className="projects-scope-toggle__icon" size={18} />
    <span className="projects-scope-toggle__label">{label}</span>
  </button>
);

SignalFeedToggle.propTypes = {
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default SignalFeedToggle;
